enum HttpStatus {
    TOKEN_EXPIRED = 490,
}

export default HttpStatus;
